module.exports = __webpack_public_path__ + "img/1_graph.d58b6fab.svg";